"use client";

import type { ComponentPropsWithRef } from "react";
import { forwardRef } from "react";
import { cn } from "@/core/shared/v2/lib/utils";
import type { InputWrapperWrap } from "./input-wrapper";
import { InputWrapper } from "./input-wrapper";

export interface InputProps extends ComponentPropsWithRef<"input"> {
  wrap?: InputWrapperWrap;
  showCheckIcon?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, wrap = true, showCheckIcon = false, ...props }, ref) => {
    const inputStyles =
      "flex h-12 w-full rounded-md border border-stone-400 bg-background px-3 py-2 text-base text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:border-stone-400 disabled:opacity-50 disabled:select-none enabled:aria-invalid:border-destructive md:text-sm";
    const inputElement = <input ref={ref} className={cn(inputStyles, className)} {...props} />;

    return wrap ? (
      <InputWrapper wrap={wrap} showCheckIcon={showCheckIcon}>
        {inputElement}
      </InputWrapper>
    ) : (
      inputElement
    );
  },
);

Input.displayName = "Input";
